<template>
  <v-dialog v-model="dialog" max-width="350" persistent>
    <template v-slot:activator="{ on }">
      <v-list-item v-on="on">
        <v-list-item-avatar
          style="cursor: pointer"
          color="grey lighten-3"
          class="mr-2 mt-2"
          size="40"
        >
          <v-icon dark>mdi-plus</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title> Nuova Varietà </v-list-item-title>
          <v-list-item-subtitle>Inserisci nuova varietà</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <v-card>
      <v-card-title class="headline font-italic font-weight-light primary--text"
        >Nuova Varietà</v-card-title
      >
      <v-form v-model="valid" ref="form">
        <v-card-text>
          <v-row>
            <v-col cols="12" md="12">
              <v-select
                hide-details
                label="Series"
                outlined
                v-model="serie"
                :items="specie.series"
                item-text="nome"
                item-value="id"
                prepend-icon="mdi-sprout"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12">
              <v-text-field
                hide-details
                label="Nome"
                outlined
                v-model="nome"
                prepend-icon="mdi-seal"
                :rules="rules"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                v-if="!loading"
                outlined
                hide-details
                prepend-icon="mdi-palette"
                label="Colore"
                :items="colori_disp_filter"
                item-text="nome"
                item-value="id"
                v-model="id_colore"
              >
                <template v-slot:item="data">
                  <!-- <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content
                      v-text="data.item"
                    ></v-list-item-content>
                  </template> -->
                  <template>
                    <v-list-item-avatar>
                      <v-img :src="avatar_colore(data.item)" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.nome"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-autocomplete
                outlined
                prepend-icon="mdi-account"
                label="Fornitore"
                :items="fornitori"
                item-text="nome"
                item-value="id"
                v-model="id_fornitore"
              >
                <template v-slot:item="data">
                  <!-- <template v-if="typeof data.item !== 'object'">
                    <v-list-item-content
                      v-text="data.item"
                    ></v-list-item-content>
                  </template> -->
                  <template>
                    <v-list-item-avatar>
                      <v-img :src="avatar_fornitore(data.item.id)" />
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title
                        v-html="data.item.nome"
                      ></v-list-item-title>
                    </v-list-item-content>
                  </template>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
      </v-form>

      <v-card-actions>
        <v-spacer />

        <v-btn text color="grey" @click="close()">Annulla</v-btn>
        <v-btn color="green" outlined @click="invia" :loading="loading_btn"
          ><v-icon class="mr-2">mdi-check</v-icon> Fatto</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
// import axios from "axios";
export default {
  components: {},
  props: {
    specie: Object,
    colori: Array,
  },
  data() {
    return {
      dialog: false,
      nome: "",
      serie: "",
      id_fornitore: null,
      id_colore: null,
      valid: true,
      rules: [(v) => !!v || "Immettere Valore"],
      loading: true,
      loading_btn: false,
      colori_disp: [],
    };
  },
  watch: {
    "specie.colori": {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length) {
          this.fetchAllColors();
          this.loading = false;
        }
      },
    },
  },
  // async mounted() {
  //   try {
  //     for (const id_colore of this.specie.colori) {
  //       const result = await this.$store.dispatch(
  //         "fetch_colore_by_id",
  //         id_colore
  //       );
  //       this.colori_disp.push(result);
  //     }
  //   } finally {
  //     this.loading = false;
  //   }
  // },
  computed: {
    fornitori() {
      return this.$store.getters.get_fornitori;
    },
    colori_disp_filter() {
      return this.colori.filter(
        (colore) =>
          colore.id_series.includes(this.serie) || colore.id_series.length == 0
      );
    },
  },
  methods: {
    async fetchAllColors() {
      this.colori_disp = [];
      for (const id_colore of this.specie.colori) {
        const result = await this.$store.dispatch(
          "fetch_colore_by_id",
          id_colore
        );
        this.colori_disp.push(result);
      }
    },
    avatar_fornitore(id_fornitore) {
      return (
        process.env.VUE_APP_API_ROOT + "/fornitore/" + id_fornitore + "/avatar"
      );
    },
    avatar_colore(colore) {
      return (
        process.env.VUE_APP_API_ROOT +
        "/specie/" +
        "img_colore/" +
        colore.id +
        "?t=" +
        colore.md5
      );
    },
    invia() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loading_btn = true;
        this.$store
          .dispatch("nuova_varieta_specie", {
            serie: this.serie,
            nome: this.nome,
            id_specie: this.specie.id,
            id_colore: this.id_colore,
            id_fornitore: this.id_fornitore,
            md5_colore: this.colori_disp.find(
              (colore) => colore.id == this.id_colore
            ).md5,
          })
          .finally(() => {
            this.loading_btn = false;
            this.dialog = false;
          });
      }
    },
    close() {
      this.nome = "";
      this.dialog = false;
    },
  },
};
</script>